import React from 'react';
import {
  AllowedComponentsContainer,
  AllowedComponentsProperties,
  Container,
  ContainerState,
} from '@adobe/aem-react-editable-components';
import { CustomAllowedComponentPlaceholderList } from './AllowedComponentPlacehiolderList';

export class CustomAllowedComponentsContainer<
  T extends AllowedComponentsProperties,
  U extends ContainerState,
> extends Container<T, U> {
  public render(): JSX.Element {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { allowedComponents, _allowedComponentPlaceholderListEmptyLabel, title, isInEditor } = this.props;

    if (isInEditor && allowedComponents && allowedComponents.applicable) {
      const emptyLabel =
        (_allowedComponentPlaceholderListEmptyLabel as string) ||
        AllowedComponentsContainer.defaultProps._allowedComponentPlaceholderListEmptyLabel;

      return (
        <CustomAllowedComponentPlaceholderList
          title={title}
          emptyLabel={emptyLabel}
          components={allowedComponents.components}
          placeholderProps={this.placeholderProps}
          cqPath={this.props.cqPath}
        />
      );
    }

    if (!this.props.cqItemsOrder.includes('responsivegrid')) {
      return (
        <main {...this.containerProps}>
          {this.childComponents}
          {this.placeholderComponent}
        </main>
      );
    }

    return super.render();
  }
}
